import moment from 'moment';

const isAppointmentDateInRange = (dateFilter, appointmentDate) => {
  const today = moment({}).utc();
  const currTime = appointmentDate.utc();
  switch (dateFilter) {
    case 'Past':
      return currTime.isBefore(today);
    case 'Upcoming':
      return currTime.isAfter(today);
    case 'All':
    default:
      return true;
  }
};

// string compare is case insensitive by using toLowerCase
const metFilterCriteria = (filter, gridAppointment) =>
  (!filter.provider ||
    (filter.provider.toLowerCase() ===
      (gridAppointment.provider || '').toLowerCase().trim())) &&
  (!filter.status ||
    (filter.status.toLowerCase() ===
      (gridAppointment.status || '').toLowerCase().trim())) &&
  (!filter.appointmentType ||
    (filter.appointmentType.toLowerCase() ===
      (gridAppointment.type || '').toLowerCase().trim())) &&
  (!filter.date ||
    isAppointmentDateInRange(filter.date, moment(gridAppointment.date)));

// Do not apply filter if filter in state is undefined
// or none of the properties exists (undefined)
// or the property value is blank.
const noFilterApplied = (filter) => !filter ||
  (!filter.provider &&
  !filter.appointmentType &&
  !filter.status &&
  !filter.date);

export const applyFilter = (filter, appointments) => {
  if (!appointments) {
    return null;
  }
  let filteredAppointments = [];
  if (noFilterApplied(filter)) {
    filteredAppointments = appointments;
  } else {
    filteredAppointments = appointments.map(
      (appointment) => (
        metFilterCriteria(filter, appointment) ?
          ({ ...appointment, isFiltered: false }) :
          ({ ...appointment, isFiltered: true })
      )
    );
  }

  return filteredAppointments;
};
